import React, { useEffect, useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import { Spinner, Card, CardBody } from "reactstrap";
import { t } from "i18next";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { getLead } from "../../../api/lead";
import { getLeadSource } from "../../../api/leadSource";
import { getAdmin } from "../../../api/admins";
import { getBusinessCategory } from "../../../api/businessCategory";
import LeadContactData from "./LeadContentData";

export default function LeadShow() {
    const { id } = useParams();
    const [lead, setLead] = useState(null);
    const [loading, setLoading] = useState(true);
    const [hasAccess, setHasAccess] = useState(false);
    const [leadSource, setLeadSource] = useState("");
    const [assignedTo, setAssignedTo] = useState("");
    const [businessCategory, setBusinessCategory] = useState("");

    const currentUser = useMemo(() => {
        return JSON.parse(localStorage.getItem("currentUser")) || {};
    }, []);

    const role = currentUser.role || currentUser.roleName || "";

    const hasPermission = (action) => {
        if (role === "super admin" || role?.name === "super admin") return true;
        return (
            role.permissions &&
            role.permissions.some(
                (perm) => perm.resource === "Monitor" && perm.actions.includes(action)
            )
        );
    };

    const canRead = () => hasPermission("update") || hasPermission("delete") || hasPermission("read");

    useEffect(() => {
        if (!canRead()) {
            setHasAccess(false);
            setLoading(false);
            return;
        }
        setHasAccess(true);

        const fetchLeadData = async () => {
            try {
                const res = await getLead(id);
                const leadData = res?.data;
                setLead(leadData);
                console.log("res", res);
                if (leadData?.leadSource) {
                    const leadSourceRes = await getLeadSource(leadData.leadSource._id || leadData.leadSource);
                    setLeadSource(leadSourceRes?.data?.name || "");
                }

                if (leadData?.assignedTo) {
                    const assignedToRes = await getAdmin(leadData.assignedTo._id || leadData.assignedTo);
                    setAssignedTo(assignedToRes?.data?.name || "");
                }

                if (leadData?.businessCategory) {
                    const categoryRes = await getBusinessCategory(leadData.businessCategory._id || leadData.businessCategory);
                    setBusinessCategory(categoryRes?.data?.name || "");
                }

            } catch (err) {
                console.error("Error fetching lead data:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchLeadData();
    }, [id]);

    if (loading) return <Spinner color="primary" />;

    if (!hasAccess) {
        return <div>{t("You do not have permission to view this lead.")}</div>;
    }

    if (!lead) return <div>{t("Lead not found.")}</div>;

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs title={t("Lead Details")}
                    addUrl={id ? `/leads` : null}
                />
                <Card className="mt-4">
                    <CardBody>
                        <p>
                            <strong>{t("Name")}:</strong> {lead.name || t("N/A")}
                        </p>
                        <p>
                            <strong>{t("Email")}:</strong> {lead.email || t("N/A")}
                        </p>
                        <p>
                            <strong>{t("Phone")}:</strong> {lead.phone || t("N/A")}
                        </p>
                        <p>
                            <strong>{t("WhatsApp")}:</strong> {lead.whatsApp || t("N/A")}
                        </p>
                        <p>
                            <strong>{t("Lead Source")}:</strong> {leadSource || t("N/A")}
                        </p>
                        <p>
                            <strong>{t("Assigned To")}:</strong> {assignedTo || t("N/A")}
                        </p>
                        <p>
                            <strong>{t("Business Category")}:</strong> {businessCategory || t("N/A")}
                        </p>
                        <LeadContactData leadId={id} />
                    </CardBody>
                </Card>
            </div>
        </div>
    );
}
